import { Heading, VStack } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { CustomersTable } from '~/valleyBank/domains/Customers/ui/overview/CustomersTable';

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="./" />;
    }}
  >
    <VStack spacing="32px" alignItems="flex-start">
      <Heading as="h2" mb="60px">
        Customers
      </Heading>
      <CustomersTable />
    </VStack>
  </RouteErrorBoundary>
);
